import { t } from '@lingui/macro';
import {
    useEffect, useRef, useState
} from 'react';

type Options = {
    onExpiredCountdown: () => any
    durationSecs: number
};

export function useExpireTimer ({
    onExpiredCountdown, durationSecs
}: Options) {
    const startedRef = useRef(Date.now());
    const expired = useRef(false);
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        if (expired.current) {
            return;
        }

        setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
    });

    function calculateTimeLeft () {
        // get the number of seconds that have elapsed
        const diff = durationSecs - (((Date.now() - startedRef.current) / 1000) | 0);

        if (diff <= 0 && !expired.current) {
            onExpiredCountdown();
            expired.current = true;

            return '';
        }

        // does the same job as parseInt truncates the float
        const minutes = (diff / 60) | 0;
        const seconds = (diff % 60) | 0;
        const minutesPadded = minutes < 10 ? '0' + minutes : minutes;
        const secondsPadded = seconds < 10 ? '0' + seconds : seconds;

        return `${t`session.expiring`} ${minutesPadded}:${secondsPadded} ${t`minutes`}`;
    }

    return timeLeft;
}
